import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTES } from 'app-constants/routes';
import { AccessControl } from 'components/AccessControl';
import { PermissionDenied } from 'pages';
import { useSelector } from 'react-redux';
import { userSelectors } from 'store/user/selectors';
import Connectors from 'pages/Connectors';
import ExternalNotifications from 'pages/ExternalNotifications';
import MediaCluster from 'pages/MediaCluster';
import { UserPermission } from '../store/user/types';

const UsersPage = lazy(() => import('pages/AdminManagement/Users'));
const WimsPage = lazy(() => import('pages/AdminManagement/Wims'));
const GroupsPage = lazy(() => import('pages/AdminManagement/Groups'));
const AdminHomePage = lazy(() => import('pages/AdminManagement/Home'));
const SettingsPage = lazy(() => import('pages/AdminManagement/Settings'));
const AdministrationPage = lazy(() => import('pages/AdminManagement/UserGroups'));
const UserLogsPage = lazy(() => import('pages/AdminManagement/UserLogs'));
const ValidationRules = lazy(() => import('pages/AdminManagement/ValidationRules'));

export const AdminNavigationRouter: React.FC = () => {
  const user = useSelector(userSelectors.getUser);

  return (
    <Suspense fallback={<PermissionDenied />}>
      <Switch>
        <Route
          exact
          path={ROUTES.AdminHome}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <AdminHomePage />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.AdminUsers}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <UsersPage />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.AdminWims}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <WimsPage />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.AdminGroups}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <GroupsPage />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.AdminUserGroups}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <AdministrationPage />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.AdminUserLogs}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <UserLogsPage />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.ServerMonitoring}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <MediaCluster />
            </AccessControl>
          )}
        />

        <Route
          exact
          path={ROUTES.ExternalNotifications}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <ExternalNotifications />
            </AccessControl>
          )}
        />

        <Route
          exact
          path={ROUTES.ExternalConnectors}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <Connectors />
            </AccessControl>
          )}
        />
        <Route
          exact
          path={ROUTES.ValidationRules}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <ValidationRules />
            </AccessControl>
          )}
        />

        <Route
          exact
          path={ROUTES.SystemSettings}
          render={() => (
            <AccessControl
              acl={[UserPermission.WRITE, UserPermission.ADMIN, UserPermission.SYSTEM_ADMIN]}
              permissions={user?.permissions}
              redirect
            >
              <SettingsPage />
            </AccessControl>
          )}
        />
      </Switch>
    </Suspense>
  );
};
